async function hydrateKlaviyoFavorite(button) {
  if (!button || button.dataset.klaviyoHydrated === 'true') return;

  const productUrl = button.getAttribute('product-url');
  if (!productUrl) return;

  button.dataset.klaviyoHydrated = 'loading';

  try {
    const response = await fetch(`${productUrl}.js`);
    const product = await response.json();

    const variant =
      product.variants.find(variant => variant.available) ||
      product.variants[0];

    if (!variant?.id) {
      button.dataset.klaviyoHydrated = 'failed';
      return;
    }

    button.setAttribute('variant-id', variant.id);
    button.dataset.klaviyoHydrated = 'true';

    if (typeof button.renderWidget === 'function') {
      button.renderWidget();
    }
  } catch (error) {
    button.dataset.klaviyoHydrated = 'failed';
    console.error('Klaviyo Favorites hydration failed:', error);
  }
}

function hydrateKlaviyoFavorites(root = document) {
  root
    .querySelectorAll?.('product-item klaviyo-favorites-button[icon-only]')
    .forEach(hydrateKlaviyoFavorite);
}

function initKlaviyoFavoritesPLP() {
  hydrateKlaviyoFavorites();

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;

        if (
          node.matches?.('product-item klaviyo-favorites-button[icon-only]')
        ) {
          hydrateKlaviyoFavorite(node);
        } else {
          hydrateKlaviyoFavorites(node);
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKlaviyoFavoritesPLP);
} else {
  initKlaviyoFavoritesPLP();
}